"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var styles = require("../CartConfiguration.scss");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var Utils = require("../../../utils/UtilityFunctions");
var components_1 = require("@idp/duc/components");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var add_newline_modal_1 = require("@sales/add-newline-modal");
var TVLaterAlert_1 = require("../../panels/TVLaterAlert/TVLaterAlert");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var CartConfigurationExtender = /** @class */ (function (_super) {
    __extends(CartConfigurationExtender, _super);
    function CartConfigurationExtender(props) {
        var _this = _super.call(this, props) || this;
        _this.sendImpressionEvent = function () {
            var payload = Utils.getCartResp();
            var impressionData = {
                componentName: 'Alert Warning',
                contentFriendlyName: 'WAL Banner',
                contentSystem: 'SCMS',
            };
            // tslint:disable-next-line: no-unused-expression
            (payload === null || payload === void 0 ? void 0 : payload.isAccountLocked) && _this.reportingService.sendImpressionEvent(impressionData);
        };
        _this.reportingService = new ReportingService_1.default();
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.boolLoading = _this.boolLoading.bind(_this);
        _this.moveToDeliveryPanel = _this.moveToDeliveryPanel.bind(_this);
        _this.getRTINoCommonDeliveryErrorMessage = _this.getRTINoCommonDeliveryErrorMessage.bind(_this);
        _this.setNoCommonDeliveryErrorState = _this.setNoCommonDeliveryErrorState.bind(_this);
        _this.sisfoMessageOnlyOncePerSession = _this.sisfoMessageOnlyOncePerSession.bind(_this);
        _this.fireCartPageReportingEvents = _this.fireCartPageReportingEvents.bind(_this);
        _this.checkCouponCode = _this.checkCouponCode.bind(_this);
        _this.displayFNModal = _this.displayFNModal.bind(_this);
        _this.handleFNAddALineModal = _this.handleFNAddALineModal.bind(_this);
        _this.CRPLaterOfferMessage = _this.CRPLaterOfferMessage.bind(_this);
        _this.renderTVLaterAlert = _this.renderTVLaterAlert.bind(_this);
        _this.tvLaterComp = _this.tvLaterComp.bind(_this);
        return _this;
    }
    CartConfigurationExtender.prototype.setNoCommonDeliveryErrorState = function (rtiErrorDetails) {
        if (Object.keys(rtiErrorDetails).length > 0) {
            this.setState({
                deliveryPanelLink: rtiErrorDetails === null || rtiErrorDetails === void 0 ? void 0 : rtiErrorDetails.deliveryPanelLink,
                shippingAddrZip: rtiErrorDetails === null || rtiErrorDetails === void 0 ? void 0 : rtiErrorDetails.shippingAddrZip,
                showRtiNoCommonDeliveryError: rtiErrorDetails === null || rtiErrorDetails === void 0 ? void 0 : rtiErrorDetails.showRtiError,
            });
        }
    };
    CartConfigurationExtender.prototype.getRTINoCommonDeliveryErrorMessage = function (wlsCMS) {
        var _this = this;
        var _a;
        var rtiNoDeliveryZipLabel = ((_a = wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiNoDeliveryZipLabel) === null || _a === void 0 ? void 0 : _a.replace('{zip}', this.state.shippingAddrZip)) ||
            "Based on zip code " + this.state.shippingAddrZip + " this device does not have a delivery method available.";
        var rtiContinueOrderLabel = (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiContinueOrderLabel) || 'To continue with your order:';
        var rtiDeliveryAddressLabel = (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiDeliveryAddressLabel) || 'Enter a different delivery address';
        var rtiDeliveryOptionsLabel = (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiDeliveryOptionsLabel) || " to check your local delivery options";
        var rtiOrLabel = (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiOrLabel) || '-- OR --';
        var rtiRemoveItemLabel = (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.rtiRemoveItemLabel) || 'Remove 1 item from your order';
        var displayMessage = this.state.showRtiNoCommonDeliveryError && (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: false, onWhite: true, testId: utils_1.default('Cart', 'RTIError', '_msg'), type: "error" },
            React.createElement(ui_components_1.Label, { data: { text: rtiNoDeliveryZipLabel }, options: { className: styles.rtiNoDeliveryMsg } }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(ui_components_1.Label, { data: { text: rtiContinueOrderLabel }, options: { className: [styles.rtiNoDeliveryMsg, styles.pb8].join(' ') } }),
            React.createElement("br", null),
            React.createElement("span", { className: styles.rtiRemoveMsg },
                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'DeliveryPanel'), className: styles.linkText, 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () { _this.moveToDeliveryPanel(); } }, rtiDeliveryAddressLabel),
                rtiDeliveryOptionsLabel),
            React.createElement("br", null),
            React.createElement(ui_components_1.Label, { data: { text: rtiOrLabel }, options: { className: [styles.rtiErrorMsg, styles.attBoldText].join(' ') } }),
            React.createElement("br", null),
            React.createElement(ui_components_1.Label, { data: { text: rtiRemoveItemLabel }, options: { className: styles.rtiRemoveMsg } }))));
        return displayMessage || React.createElement(React.Fragment, null);
    };
    CartConfigurationExtender.prototype.moveToDeliveryPanel = function () {
        var panelElement = document.querySelectorAll("[data-test-id=" + this.state.deliveryPanelLink + "]")[0];
        if (panelElement) {
            panelElement.focus();
            panelElement.scrollIntoView();
        }
    };
    // tslint:disable-next-line: no-any
    CartConfigurationExtender.prototype.showAllPlansUpadatedWarningMsg = function (payload, multidevicePlanUpdateMsg) {
        var _a;
        if ((payload === null || payload === void 0 ? void 0 : payload.wirelessCart) && ((_a = payload === null || payload === void 0 ? void 0 : payload.wirelessCart) === null || _a === void 0 ? void 0 : _a.insuranceItemPriceUpdated) && multidevicePlanUpdateMsg) {
            return (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'RTIError', '_msg'), type: "success" },
                React.createElement("div", { "data-test": "showAllPlansUpadatedWarningMsg", className: styles.rtiErrorMsg, dangerouslySetInnerHTML: { __html: multidevicePlanUpdateMsg } }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    CartConfigurationExtender.prototype.boolLoading = function (bool) {
        this.setState({ isLoading: bool });
    };
    // tslint:disable-next-line: no-any
    CartConfigurationExtender.prototype.displayInsuranceUpdatedAlert = function (losgs) {
        var _a, _b;
        var insuranceName = '';
        var insuranceUpdated = false;
        if (losgs) {
            Object.keys(losgs).forEach(function (losgItemKey, index) {
                Object.keys(losgs[losgItemKey].lineItems).forEach(function (lineItemKey) {
                    var lineItem = losgs[losgItemKey].lineItems[lineItemKey];
                    if (lineItem.uiDisplayLineItem && lineItem.itemType.toUpperCase() === 'FEATURE') {
                        insuranceName = lineItem.displayName;
                    }
                });
                if (losgs[losgItemKey].insuranceItemUpdated) {
                    insuranceUpdated = true;
                }
            });
        }
        if (insuranceUpdated) {
            return (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'InsuranceUpdated', '_msg'), type: "warning" },
                React.createElement(ui_components_1.Label, { data: {
                        text: (_b = (_a = this.cartConfigurationCMSData) === null || _a === void 0 ? void 0 : _a.insuranceUpdated) === null || _b === void 0 ? void 0 : _b.replace('{0}', insuranceName),
                    }, options: {
                        className: styles.rtiErrorMsg,
                    } }))));
        }
    };
    CartConfigurationExtender.prototype.sisfoMessageOnlyOncePerSession = function () {
        var messageStatus = this.stateManager.get('CART', 'sisfoMsgOnlyOncePerSession');
        if ((messageStatus && messageStatus.show) || (messageStatus === null)) {
            this.stateManager.set('sisfoMsgOnlyOncePerSession', { show: true });
            return true;
        }
        else {
            return false;
        }
    };
    CartConfigurationExtender.prototype.fireCartPageReportingEvents = function (formattedinsurance) {
        if (this.props && this.props.data && this.props.options && this.props.options.triggerReportingEvents) {
            if (this.props.options.triggerReportingEvents.triggerCartPageLoad) {
                this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE, true);
            }
            if (this.props.options.triggerReportingEvents.triggerCartDisplaySystemEvent) {
                this.reportingService.fireCartSummaryDisplay(formattedinsurance);
                this.sendImpressionEvent();
            }
        }
    };
    CartConfigurationExtender.prototype.showCouponReminder = function () {
        var _a;
        var wlsCMS = wlsUtils.getWlsCmsData();
        var couponCodeApplied = false;
        var couponCode = ' ';
        var couponMsg = '';
        var campaignCookie = false;
        var campaignCoupons = this.campaignCouponCmsData;
        if (campaignCoupons && this.cookieVal) {
            for (var _i = 0, _b = campaignCoupons.campaignOffers; _i < _b.length; _i++) {
                var offer = _b[_i];
                if (offer && offer.campaignId === this.cookieVal) {
                    if (this.cookieVal === offer.campaignId) {
                        campaignCookie = true;
                    }
                    couponCode = offer.couponId;
                    couponMsg = "[ " + offer.couponId + " ]";
                    break;
                }
            }
        }
        var couponApplied = this.checkCouponCode();
        if (couponApplied) {
            for (var _c = 0, couponApplied_1 = couponApplied; _c < couponApplied_1.length; _c++) {
                var offerApplied = couponApplied_1[_c];
                if (offerApplied.couponCode === couponCode) {
                    couponCodeApplied = true;
                    break;
                }
            }
        }
        var customerCampaignMsg = wlsCMS.customerCampaignReminderMsg || "Use code <span> {0} </span> to get your discount";
        customerCampaignMsg = customerCampaignMsg.replace('{0}', (_a = (couponMsg)) === null || _a === void 0 ? void 0 : _a.toString());
        if (campaignCookie && !couponCodeApplied) {
            return (React.createElement("div", { className: styles.mb10 }, React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'RTIError', '_msg'), type: "info" },
                React.createElement("div", { className: styles.rtiErrorMsg, dangerouslySetInnerHTML: { __html: customerCampaignMsg } }))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    CartConfigurationExtender.prototype.checkCouponCode = function () {
        var payload = Utils.getCartResp();
        var couponCodeAdded;
        if (payload && payload.wirelessCart
            && payload.wirelessCart.promotions) {
            couponCodeAdded = payload.wirelessCart.promotions;
        }
        if (payload && payload.broadbandCart
            && payload.broadbandCart.promotions) {
            couponCodeAdded = payload.broadbandCart.promotions;
        }
        return couponCodeAdded;
    };
    CartConfigurationExtender.prototype.displayFNModal = function (fnCaribbean) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var campaignId = Utils.getCampaignSessionId();
        var redirectUrls = {
            hotspot: '/buy/postpaid/connected-devices-and-more',
            smartphone: '/buy/postpaid/phones',
            tablet: '/buy/postpaid/tablets',
            wearable: '/buy/postpaid/wearables',
        };
        return (React.createElement(ui_components_1.Modal, { testId: "Modal_AAL_FN", options: { center: true, className: { modalContentClass: styles.rennyModalCloseBtn },
                show: this.state.isFNModalOpen, showClose: true, tabIndex: 0 }, events: { onClose: function () { return _this.handleFNAddALineModal(false); } }, accessibilityText: "_AAL_Modal_FN" },
            React.createElement(add_newline_modal_1.AddNewLineModal, { flowType: add_newline_modal_1.FlowTypes.AAL, heading: (_a = this.wirelessCmsData) === null || _a === void 0 ? void 0 : _a.aalModalHeading, selectMemberText: (_b = this.wirelessCmsData) === null || _b === void 0 ? void 0 : _b.aalModalMemberText, tab1Heading: (_c = this.wirelessCmsData) === null || _c === void 0 ? void 0 : _c.aalTab1Heading, tab2Heading: (_d = this.wirelessCmsData) === null || _d === void 0 ? void 0 : _d.aalTab2Heading, tab1Copy: (_e = this.wirelessCmsData) === null || _e === void 0 ? void 0 : _e.aalTab1Copy, tab2Copy: (_f = this.wirelessCmsData) === null || _f === void 0 ? void 0 : _f.aalTab2Copy, submitBtnText: (_g = this.wirelessCmsData) === null || _g === void 0 ? void 0 : _g.aalSubmitBtnText, submitBtnRedirectUrls: redirectUrls, campaignIdHeader: campaignId, suppressFamilyMemberBtn: fnCaribbean })));
    };
    CartConfigurationExtender.prototype.handleFNAddALineModal = function (bool) {
        this.setState({ isFNModalOpen: bool });
    };
    CartConfigurationExtender.prototype.CRPLaterOfferMessage = function () {
        var _a;
        if (Utils.isAALFlow()) {
            return;
        }
        if (this.state.isStandaloneCRP && ((_a = this.wirelessCmsData) === null || _a === void 0 ? void 0 : _a.crpLaterLabelInfo)) {
            return (React.createElement("div", null,
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, testId: utils_1.default('Cart', 'changePlanOfferCrp', 'msg'), type: "info" },
                    React.createElement(ui_components_1.Label, { testId: utils_1.default('Cart', 'changePlanOfferCrp', 'label'), data: { text: this.wirelessCmsData.crpLaterLabelInfo }, options: { className: styles.changePlanOfferCrp } }))));
        }
        return (React.createElement(React.Fragment, null, " "));
    };
    CartConfigurationExtender.prototype.renderTVLaterAlert = function (userInfoTVLaterMessage, userInfoTVLaterSubMessage, userInfoTVLaterPhone) {
        return (React.createElement(TVLaterAlert_1.default, { userInfoTVLaterMessage: userInfoTVLaterMessage, userInfoTVLaterSubMessage: userInfoTVLaterSubMessage, userInfoTVLaterPhone: userInfoTVLaterPhone }));
    };
    CartConfigurationExtender.prototype.tvLaterComp = function (tvHeading, tvLaterAlertContent) {
        var tvLaterData = {
            dueTodayPrice: 0,
            hideDueTodayPrice: true,
            lineOfBusinessName: "" + tvHeading,
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(CartViewPanel_1.default, { data: tvLaterData, events: { onEdit: function () {
                        '';
                    } }, options: { hideEditAndRemove: true, planType: CartViewPanelProps_1.PlanType.DTVNOW, hidedueTodaySeeDetails: true }, tvLaterBBExperience: true }),
            React.createElement("div", null,
                React.createElement(components_1.Alert, { testId: "tv-section-info-alert", className: styles.tvLaterAlertStyle + " alertStyle" },
                    React.createElement("div", { "data-testid": "tv-section-content", className: styles.tvLaterContentStyle }, tvLaterAlertContent)))));
    };
    CartConfigurationExtender.prototype.renderAccountLockMessage = function (wlsCMS) {
        return (React.createElement(components_1.Alert, { closeable: false, type: "warning" },
            React.createElement("div", null,
                React.createElement("span", { className: "border-dark-gray type-base", style: { fontWeight: 'bold' } }, (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.accountLockWarningMsg1) ? wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.accountLockWarningMsg1 : "Your Wireless Account Lock is turned on. "),
                React.createElement("span", { className: "type-base" }, (wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.accountLockWarningMsg2) ? wlsCMS === null || wlsCMS === void 0 ? void 0 : wlsCMS.accountLockWarningMsg2 :
                    "To place an order, turn this feature off in the myAT&T app, return to cart, and refresh the page."))));
    };
    return CartConfigurationExtender;
}(React.Component));
exports.default = CartConfigurationExtender;
//# sourceMappingURL=CartConfigurationExtender.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartConfigurationContainer/CartConfigurationExtender/CartConfigurationExtender.js
// module id = 797
// module chunks = 8